angular.module('ihestiaRestServicesBase')
  .factory('ihestiaRestVehicleDictionaryRegistrationTypesSvc', ['ihestiaRestAbstractVehicleDictionariesSvc',
    function(ihestiaRestAbstractVehicleDictionariesSvc) {

      var RestDictionaryVehicleSvc = function() {
        ihestiaRestAbstractVehicleDictionariesSvc.apply(this, arguments);

        this.id = 'registrationTypes';

      };
      return new RestDictionaryVehicleSvc();
    }
  ]);